import { useEffect, useState } from 'react';

/**
 * Returns a debounced copy of `value` that only updates after `value` has held
 * steady for `delayMs`. Used by the file-browser search box so typing doesn't
 * fire one request per keystroke — debouncing is what keeps a fast typist (or a
 * shared office NAT IP) clear of the WAF's per-IP rate limit.
 *
 * The latest update wins: each change cancels the previous pending timer, so
 * only the last value within a quiet window is committed.
 */
export function useDebouncedValue<T>(value: T, delayMs: number): T {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(timer);
  }, [value, delayMs]);

  return debounced;
}
